<template>
  <div class="saddle-step-four">
    <v-switch
      v-model="form.idc_tablet"
      hide-details
      label="Tablette :"
      class="title"
      @change="clearTabletFields"
    />

    <v-radio-group
      v-model="form.tablet_type"
      row
      :disabled="!form.idc_tablet"
    >
      <v-radio
        label="Guidon "
        value="HANDLEBARS"
      />
      <v-radio
        label="Tablette"
        value="TABLET"
      />
    </v-radio-group>

    <v-layout
      justify-space-between
      mb-8
    >
      <v-flex sm6>
        <v-textarea
          v-model="form.tablet_comments"
          filled
          name="Commentaires :"
          label="Commentaires :"
          :disabled="!form.idc_tablet"
        />
      </v-flex>

      <v-flex
        column
        sm6
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_4a.svg">
            <v-text-field
              v-model="form.tablet_a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema A"
              :class="{ error: errors.has('(Tablette) Schema A') }"
              outlined
              type="number"
              label="mm"
              style="top: -0.2%;left: 54.2%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema B"
              :class="{ error: errors.has('(Tablette) Schema B') }"
              outlined
              type="number"
              label="mm"
              style="top: 38.1%;left: 44.1%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema C"
              :class="{ error: errors.has('(Tablette) Schema C') }"
              outlined
              type="number"
              label="mm"
              style="top: 65.4%;left: 28.4%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema D"
              :class="{ error: errors.has('(Tablette) Schema D') }"
              outlined
              type="number"
              label="mm"
              style="top: 86.4%;left: 54.2%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema E"
              :class="{ error: errors.has('(Tablette) Schema E') }"
              outlined
              type="number"
              label="mm"
              style="top: 65.4%;left: 81.1%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
            <v-text-field
              v-model="form.tablet_f"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema F"
              :class="{ error: errors.has('(Tablette) Schema F') }"
              outlined
              type="number"
              label="mm"
              style="top: 61.6%;left: 0.1%;"
              height="100%"
              :disabled="!form.idc_tablet"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
      v-for="(article, index) in articlesList"
      :key="index"
      class="checkbox-input-container"
    >
      <v-flex>
        <v-checkbox
          v-if="form.articles[index]"
          v-model="form.articles[index].idc_want"
          :label="article.label"
          hide-details
        >
          <template v-slot:label>
            <h4>{{ article.article_reference }}</h4>
            <h4>{{ article.label }}</h4>
          </template>
        </v-checkbox>
      </v-flex>
      <v-flex
        v-if="article.idc_entry"
        class="checkbox-input visible"
      >
        <InputNumber
          v-if="form.articles[index]"
          v-model="form.articles[index].value"
          class="input-number"
        />
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mt-8
    >
      <v-flex sm6>
        <v-textarea
          v-model="form.for_finishing"
          filled
          name="Pour la finition :"
          label="Pour la finition  :"
        />
      </v-flex>

      <v-flex sm6>
        <v-textarea
          v-model="form.for_testing"
          filled
          name="Pour l'essayage :"
          label="Pour l'essayage :"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "SaddleStepFour",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  async created() {
    this.$validator = this.parentValidator;

    await this.loadArticles("SEAT");

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },
  methods: {
    // Clear tablet fields
    clearTabletFields() {
      this.form.tablet_type = null;
      this.form.tablet_comments = null;
      this.form.tablet_a = null;
      this.form.tablet_b = null;
      this.form.tablet_c = null;
      this.form.tablet_d = null;
      this.form.tablet_e = null;
      this.form.tablet_f = null;
    }
  }
};
</script>

<style lang="scss">
.saddle-step-four {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 12.1%;
        height: 11.3%;
        @media (max-width: 800px) {
          height: 11.3%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }

  .v-textarea {
    height: 100%;
    .v-input__control {
      height: 100%;
      .v-input__slot {
        height: 100%;
      }
    }
  }

  .v-input--selection-controls {
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .v-textarea {
    height: 100%;
    .v-input__control {
      height: 100%;
      .v-input__slot {
        height: 100%;
      }
    }
  }
}
</style>
